export default "__VITE_ASSET__dd00bbd4__"